import React, { ReactElement } from 'react';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { EntityRowSpacing } from 'services/entities/types';
import { AppState } from 'services/types';
import { makeSelectRowSpacingsWithoutCalibrations } from 'services/equipmentSets/selectors';
import { EquipmentSetsProps } from 'services/equipmentSets/types';
import WarningMessage from 'components/WarningMessage';

interface ConnectedProps {
    rowSpacingsWithoutCalibrations: EntityRowSpacing[];
}

type OwnProps = EquipmentSetsProps;

export type Props = ConnectedProps & OwnProps;

export class RowSpacingsWithoutCalibrationsAlertComponent extends React.PureComponent<
    Props
> {
    render(): ReactElement | null {
        const { rowSpacingsWithoutCalibrations } = this.props;

        if (
            !rowSpacingsWithoutCalibrations ||
            !rowSpacingsWithoutCalibrations.length
        ) {
            return null;
        }

        const content = rowSpacingsWithoutCalibrations
            .map(calibration => `${calibration}m`)
            .join(', ');

        return (
            <Grid.Row>
                <Grid.Column>
                    <div className="calibration-status-section">
                        <WarningMessage
                            title="Your equipment has no setup for row widths:"
                            content={content}
                            visible
                        />
                    </div>
                </Grid.Column>
            </Grid.Row>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    rowSpacingsWithoutCalibrations: makeSelectRowSpacingsWithoutCalibrations()
});

export default connect(mapStateToProps)(
    RowSpacingsWithoutCalibrationsAlertComponent
);
